function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement, forwardRef } from "react";
import { NavLink } from "react-router-dom";
import { Button as BaseButton } from "sprout-ui-dom";
import { Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import Badge from "../Badge";
const Button = styled(BaseButton)`
  flex-direction: column;

  min-width: 48px;
  width: 100%;
  max-width: 120px;

  padding-top: 12px;
  /* padding-bottom: 32px; */
  padding-bottom: 48px;

  color: ${themeGet("colors.black.87")};

  :active {
    background: #bfbbc3;
  }
`;
const BottomNavigationButtonLabel = styled(Text)`
  ${media.down("375px")} {
    display: none;
  }
`;
const BottomNavigationButtonIconWrapper = styled(Flex)`
  ${media.down("375px")} {
    width: 56px;
  }

  ${Button}:not(:active).active & {
    background: #e6dff6;
  }
`;
const BottomNavigationButton = /*#__PURE__*/ forwardRef((props, ref)=>{
    // const { label, icon, to, badge, ...rest } = props;
    const { icon , to , badge  } = props, rest = _objectWithoutProperties(props, [
        "icon",
        "to",
        "badge"
    ]);
    const as = _objectSpread({}, to && {
        as: NavLink,
        to
    });
    return /*#__PURE__*/ _jsxs(Button, _objectSpread({}, as, {
        ref: ref
    }, rest, {
        children: [
            /*#__PURE__*/ _jsx(BottomNavigationButtonIconWrapper, {
                as: "span",
                alignItems: "center",
                justifyContent: "center",
                height: "32px",
                width: "64px",
                borderRadius: "16px",
                mb: 0,
                children: /*#__PURE__*/ _jsxs(Flex, {
                    as: "span",
                    position: "relative",
                    children: [
                        badge && /*#__PURE__*/ _jsx(Badge, {
                            position: "absolute",
                            top: "-25%",
                            right: "-50%",
                            children: badge
                        }),
                        /*#__PURE__*/ createElement(icon)
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BottomNavigationButtonLabel, {
                as: "span",
                fontSize: 0,
                lineHeight: "16px",
                fontWeight: "medium"
            })
        ]
    }));
});
export default BottomNavigationButton;
